import { z } from 'zod';

export const TaxesSchema = z.object({
  name: z.string().optional(),
  amount: z.coerce.number().int().min(0).optional(),
  billingType: z.enum(['perDay', 'perRental']).optional(),
  required: z.boolean().default(false),
});

export const ExtendedTaxesSchema = z.object({
  taxes: z.array(TaxesSchema),
});

export type ExtendedTaxesFormData = z.infer<typeof ExtendedTaxesSchema>;
